import { createFileRoute } from '@tanstack/react-router';

import { OrganizationAdminsContainer } from '@/features/organization-admins/containers';

export const Route = createFileRoute('/_layout/organization-admins/')({
  component: OrganizationAdminsContainer,
});
